module.exports = __webpack_public_path__ + "static/media/cta-background.df4ba828.webp";